/**
 * @param min - minimum value
 * @param max - maximum value
 * @param percentage - percentage between 0 and 1
 * @returns linear interpolation between min and max
 */
export const lerp = (min: number, max: number, percentage: number): number => {
  return min * (1 - percentage) + max * percentage;
};
